<template>
    <b-overlay :show="loading" rounded="sm">
        <div>
            <view-item v-if="!!item" :item="item" @success="alertSuccess" @cancel="item = null"></view-item>

            <list-items v-if="!item" title="ItemTypes" :items="emailSchedules" @show-item="showItem" ref="table">
                <button class="btn btn-primary btn-block" variant="primary" block v-if="hasPermissionCreate"
                    @click="item = {}"><img v-b-tooltip.hover :title="$addLabel()"
                        src="@/assets/images/icon/blue-add.svg" /></button>
            </list-items>
        </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'
import { getErrorMessage } from "@/exports/error_management";

export default {
    name: 'EmailScheduler',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.$store.dispatch('emailSchedules/fetchAll')
        this.$store.dispatch('emailSchedules/fetchStatements')
    },
    computed: {
        componentName() { return this.$translate('email_schedule') },

        emailSchedules() {
            return this.$store.state.emailSchedules.items
        },
        loading() {
            return this.$store.state.emailSchedules.loading;
        },
        error() {
            return this.$store.state.emailSchedules.error;
        }
    },

    watch: {
        error: {
            handler: function (err) {
                if (!err) return;
                const msg = getErrorMessage(err);
                this.genericToast(
                    this.componentName,
                    this.$translate('error'),
                    'danger',
                    `${msg}`
                )
            },
            deep: true,
        }
    },

    methods: {
        showItem(id) {
            const item = this.emailSchedules.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, name, message) {
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" ${message}`
            )
            this.item = null
        },
    },
}
</script>
<style></style>
